export const DEFAULT_ROUTE = "/dashboard";
export const MINUTES_SIGN = "min";
export const BILLIONS_SIGN = "mld";
export const MILLIONS_SIGN = "mil";
export const THOUSANDS_SIGN = "tis";
export const EMPTY_DETAIL_FIELD = "";
export const CIRCLE_SIGN = "•";
export const ARROW_DOWN_SIGN = "↓";
export const ARROW_UP_SIGN = "↑";
export const LIST_ICON_SIZE = 32;

export const GRASS_GREEN_MYPLANN = "#0C8926";
export const BLOOD_RED_MYPLANN = "#DC2626";
export const LIGHT_GREEN_MYPLANN = "#D9FFE0";
export const LIGHT_BLUE_MYPLANN = "#2789E3";

export const SUCCESS_MYPLANN_LIGHT = "#0AAB2A";
export const SUCCESS_MYPLANN_DARK = "#3EEA60";

export const DANGER_MYPLANN_LIGHT = "#EF4444";
export const DANGER_MYPLANN_DARK = "#F87171";
export const DANGER_TERTIARY = "#FEF3F2";

export const FINANCES_INCOME_GREEN = "#409959";
export const FINANCES_EXPENSES_RED = "#F9785F";

export const BAR_MYPLANN_LIGHT = "#FAFAFA";

export const SETTINGS_FINANCES_ICON_BG = "#D1FAE5";
export const SETTINGS_FINANCES_ICON_COLOR = "#059669";
export const SETTINGS_DOCUMENTS_ICON_BG = "#E0E7FF";
export const SETTINGS_DOCUMENTS_ICON_COLOR = "#4F46E5";
export const SETTINGS_NOTIFICATIONS_ICON_BG = "#DBEAFE";
export const SETTINGS_NOTIFICATIONS_ICON_COLOR = "#2563EB";
export const SETTINGS_SECURITY_ICON_BG = "#DCFCE7";
export const SETTINGS_SECURITY_ICON_COLOR = "#16A34A";
export const SETTINGS_ACTIVITIES_ICON_BG = "#FFEDD5";
export const SETTINGS_ACTIVITIES_ICON_COLOR = "#EA580C";
export const SETTINGS_CALCULATORS_ICON_BG = "#F3E8FF";
export const SETTINGS_CALCULATORS_ICON_COLOR = "#9333EA";

export const SOLUTION_ACTION_DETAIL_ICON_BG = "#DBEAFE";
export const SOLUTION_ACTION_DETAIL_ICON_COLOR = "#2563EB";
export const SOLUTION_ACTION_UPDATE_ICON_BG = "#DCFCE7";
export const SOLUTION_ACTION_UPDATE_ICON_COLOR = "#16A34A";
export const SOLUTION_ACTION_ALLOCATION_ICON_BG = "#F3E8FF";
export const SOLUTION_ACTION_ALLOCATION_ICON_COLOR = "#9333EA";
export const SOLUTION_ACTION_UNPIN_ICON_BG = "#FEE2E2";
export const SOLUTION_ACTION_UNPIN_ICON_COLOR = "#EF4444";

export const SOLUTION_ALLOCATION_INFO_BG = "#EFF6FF";
export const SOLUTION_ALLOCATION_INFO_ICON_COLOR = "#2563EB";
export const SOLUTION_ALLOCATION_INFO_TEXT_COLOR = "#1D4ED8";
